import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const LINKS = [
  { href: "#programa", label: "El programa" },
  { href: "#cronograma", label: "Cronograma" },
  { href: "#para-quien", label: "Tu transformación" },
  { href: "#postulacion", label: "Cómo sumarte" },
  { href: "#autoras", label: "Las cuatro" },
  { href: "#sobre-mi", label: "Sobre mí" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 z-50 w-full transition-colors duration-500 ${
        scrolled || open ? "border-b border-cream/10 bg-ink/95" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="#hero" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-serif text-2xl text-cream">Bestias</span>
          <span className="hidden font-sans text-[10px] uppercase tracking-[0.3em] text-gold sm:inline">
            de la literatura
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-xs font-light tracking-wide text-bone/70 transition-colors duration-300 hover:text-cream"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#postulacion"
            data-testid="nav-cta-postularme"
            className="hidden items-center gap-2 bg-crimson px-5 py-3 text-[11px] font-medium uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:bg-crimson-light sm:flex"
          >
            Postularme <ArrowRight size={13} />
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="text-cream lg:hidden"
            aria-label="Abrir menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="border-t border-cream/10 bg-ink px-4 py-6 lg:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-light text-bone"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#postulacion"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 inline-flex w-max items-center gap-2 bg-crimson px-5 py-3 text-[11px] font-medium uppercase tracking-[0.22em] text-cream"
            >
              Postularme <ArrowRight size={13} />
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
